<ul class="breadcrumb breadcrumb-style">
  <li class="breadcrumb-item">
    <h4 class="page-title">
      <ng-content select='.title'></ng-content>
    </h4>
  </li>
  <li #ref [ngClass]="{'breadcrumb-item':true}">
    <ng-content select='.link1'></ng-content>
  </li>
  <li class="breadcrumb-item">
    <ng-content select='.link2'></ng-content>
  </li>
  <li class="breadcrumb-item active">
    <ng-content select='.active'></ng-content>
  </li>
</ul>